import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';
import ReactPaginate from 'react-paginate';

import { useIntl } from 'react-intl';

import ActionsIcon from '../Icons/ActionsIcon';
import ChevronLeftIcon from '../Icons/ChevronLeftIcon';
import ChevronRightIcon from '../Icons/ChevronRightIcon';
import styles from './EcPaginate.styles';

const EcPaginate = (prop) => {
  const intl = useIntl();
  const { classes, onPageChange, pageCount, forcePage } = prop;

  return (
    <ReactPaginate
      previousLabel={
        <span
          className={classes.iconButton}
          title={intl.formatMessage({
            id: 'pagination.previousPageTooltip',
            defaultMessage: 'go to previous page',
            description: 'Tooltip for previous page button',
          })}
        >
          <ChevronLeftIcon />
        </span>
      }
      nextLabel={
        <span
          className={classes.iconButton}
          title={intl.formatMessage({
            id: 'pagination.nextPageTooltip',
            defaultMessage: 'go to next page',
            description: 'Tooltip for next page button',
          })}
        >
          <ChevronRightIcon />
        </span>
      }
      breakLabel={<ActionsIcon />}
      previousLinkClassName={classes.paginationButtonsLinks}
      nextLinkClassName={classes.paginationButtonsLinks}
      disabledClassName={classes.disabledClassName}
      containerClassName={classes.paginationContainer}
      breakClassName={classes.paginationBrake}
      pageClassName={classes.paginationPage}
      pageLinkClassName={classes.paginatonLink}
      activeClassName={classes.paginationActivePage}
      activeLinkClassName={classes.paginatonActiveLink}
      pageCount={pageCount}
      marginPagesDisplayed={3}
      pageRangeDisplayed={2}
      onPageChange={onPageChange}
      forcePage={forcePage}
    />
  );
};

EcPaginate.propTypes = {
  classes: PropTypes.object.isRequired,
  pageCount: PropTypes.number.isRequired,
  forcePage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default injectSheet(styles)(EcPaginate);
